module.exports = __webpack_public_path__ + "7052c1713e8209b59066b446107ecf44.svg";